import React from 'react'
import Subsidiary_1 from '../../assets/images/securities.jpg';
import Subsidiary_2 from '../../assets/images/registrars.webp'
import Subsidiary_3 from '../../assets/images/trustees1.jpg';
import Subsidiary_4 from '../../assets/images/assetmanagement.jpg';
import Subsidiary_5 from '../../assets/images/commodities.jpg';
import Subsidiary_6 from '../../assets/images/property_key1.jpg';
import SubsidiariesData from './SubsidiariesData';
import './SubsidiariesStyles.css';
import { Link } from 'react-router-dom';

function Subsidiaries() {
    return (
        <div className="subsidiary">
            <h1>Our Associates</h1>
            <p>Strategic business units through which we undertake specific business activities within the varied sectors of the economy.</p>
            <div className="subsidiary-card">
                <Link target="_blank" to="https://securities.nthc.com.gh">
                    <SubsidiariesData
                        image={Subsidiary_1}
                        heading="NTHC Securities"
                        text="Securities Trading Business licensed and regulated by the Securities & Exchange Commission (SEC) and Ghana Stock Exchange (GSE)."
                    />
                </Link>
                <Link target="_blank" to="https://registrars.nthc.com.gh">
                    <SubsidiariesData
                        image={Subsidiary_2}
                        heading="NTHC Registrars"
                        text="Shares Registrar & Company Secretarial Business licensed and regulated by the Securities & Exchange Commission (SEC)."
                    />
                </Link>
                <Link target="_blank" to="https://trustees.nthc.com.gh">
                    <SubsidiariesData
                        image={Subsidiary_3}
                        heading="NTHC Trustees"
                        text="Pensions Trustees Business licensed and regulated by the National Pensions Regulatory Authority (NPRA)."
                    />
                </Link>
                <Link target="_blank" to="https://asset-management.nthc.com.gh">
                    <SubsidiariesData
                        image={Subsidiary_4}
                        heading="NTHC Asset Management"
                        text="Asset Management Business and Corporate Finance Advisory licensed and regulated by the Securities & Exchange Commission and Bank of Ghana (BOG)."
                    />
                </Link>
                {/* <Link target="_blank" to="https://commodities.nthc.com.gh">
                    <SubsidiariesData
                        image={Subsidiary_5}
                        heading="NTHC Commodities"
                        text="Commodities Trading Business licensed and regulated by the Ghana Commodity Exchange (GCX)."
                    />
                </Link> */}
                <Link target="_blank" to="https://properties.nthc.com.gh">
                    <SubsidiariesData
                        image={Subsidiary_6}
                        heading="NTHC Properties"
                        text="A Real Estates Business licensed and regulated by the Ghana Real Estates Agency."
                    />
                </Link>
            </div>
        </div>
    )
}

export default Subsidiaries
